import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { get } from 'lodash'

import { makeGetRevenueCenter } from '../../store/RevenueCenter/selector'

import EventSuiteDetails from '../../containers/Suite/Details'
import Layout from '../../components/Layout'

export const SuiteDetails = ({ rvc, eventId }) => {
  return (
    <Layout isSidebar={true} title={rvc.name} backTo={`/events/${eventId}`} iconType='close'>
      <EventSuiteDetails />
    </Layout>
  )
}

const mapStateToProps = (state, ownProps) => {
  const standId = get(ownProps, 'match.params.standId')
  const eventId = get(ownProps, 'match.params.eventId')
  const getRevenueCenter = makeGetRevenueCenter()

  const rvc = getRevenueCenter(state, standId)

  return { rvc, eventId }
}

export default withRouter(connect(mapStateToProps, null)(SuiteDetails))
